import React from "react";
import { getblog } from "../../../modules/Graphql/bloggraphql";
import Layout from "../../../container";
import { Container, Divider, Grid, Icon } from "semantic-ui-react";
import Head from "next/head";
import Router from "next/router";
import { ImageItem } from "../../../components";
import { timeAgo, customdecodeURIComponent } from "../../../common/Utils";
import he from "he";

class Blogdetails extends React.Component {
  // static async getInitialProps({ query }) {
  //   return { query };
  // }
  constructor() {
    super();
    this.state = {
      blogDetails: {},
      loading: false,
      blogData: [],
      recentLoading: false,
    };
  }

  componentDidMount = () => {
    this.getblogdetails();
    this.getallblogs();
  };

  getblogdetails = () => {
    const slug = window.location.href;
    const parts = slug.split("/");
    const pageurl = parts[parts.length - 2];

    let getdata = {
      start: 0,
      limit: 10,
      orderBy: "id",
      order: "DESC",
      fields: [
        {
          name: "pageurl",
          value: pageurl,
          operator: "=",
        },
      ],
    };
    getblog(getdata)
      .then((result) => {
        this.setState({
          blogDetails: result.data.getblog,
          loading: true,
        });
      })
      .catch((error) => {});
  };

  handleBack = () => {
    Router.push("/blog");
  };

  truncateText = (text, maxWords) => {
    const wordsArray = text.split(" ");
    if (wordsArray.length > maxWords) {
      return wordsArray.slice(0, maxWords).join(" ") + "...";
    }
    return text;
  };

  getallblogs = () => {
    let getdata = {
      start: 0,
      limit: 5,
      orderBy: "id",
      order: "DESC",
      fields: [
        {
          name: "title",
          value: "",
          operator: "!=",
        },
      ],
    };
    getblog(getdata)
      .then((result) => {
        this.setState({
          blogData: result.data.getblog,
          recentLoading: true,
        });
      })
      .catch((error) => {
        console.log("result", error);
      });
  };

  viewBlogDetails = (id) => {
    Router.push(`/blog/${id}`);
  };

  render() {
    const { loading, blogDetails, blogData, recentLoading } = this.state;
    return (
      <div className="home-wrapper">
        <Layout>
          <Container fluid style={{ padding: "0em 5em" }}>
            <Head>
              <title>
                {blogDetails && blogDetails.length > 0 && blogDetails[0].title
                  ? blogDetails[0].title
                  : "Blog"}
              </title>
              <meta
                name="description"
                content={
                  blogDetails &&
                  blogDetails.length > 0 &&
                  blogDetails[0].metadescription &&
                  blogDetails[0].metadescription
                }
              />
              <meta
                name="keywords"
                content={
                  blogDetails &&
                  blogDetails.length > 0 &&
                  blogDetails[0].metakeyword &&
                  blogDetails[0].metakeyword
                }
              />
            </Head>
            {recentLoading && (
              <div
                className="homeaccount_main blog_main"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
              >
                <Grid
                  // padded="horizontally"
                  divided
                  stackable
                  style={{
                    maxWidth: "1280px",
                    margin: "0 auto !important",
                    gridGap: "3%",
                    paddingTop: "40px",
                  }}
                >
                  <Grid.Row
                    style={{ margin: "0 auto", padding: "0px" }}
                    className="grid-container"
                  >
                    <Grid.Column
                      width={12}
                      floated="left"
                      className="full-width"
                    >
                      {blogDetails && blogDetails.length > 0 ? (
                        blogDetails?.map((item, index) => {
                          return (
                            <div key={index} className="grid-item pb20">
                              <h2 className="blog_title">
                                {customdecodeURIComponent(item.title)}
                              </h2>
                              <p>
                                {customdecodeURIComponent(
                                  item.shortdescription
                                )}
                              </p>
                              <a href={item.mappageurl}>
                                <ImageItem
                                  source={item.featuredimage}
                                  style={{ width: "100%" }}
                                  alt={item.title}
                                  className="blog_banner_img"
                                />
                              </a>
                              <div className="addTimeBlog">
                                {/* <Icon name="time" />
                                {timeAgo(item.createdtime)} */}
                              </div>
                              <Divider />
                              <div className="blogdescription">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: he.decode(
                                      customdecodeURIComponent(item.description)
                                    ),
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p>No Data Found</p>
                      )}
                    </Grid.Column>
                    <Grid.Column
                      width={4}
                      floated="right"
                      className="full-width"
                    >
                      <div className="recentBlogs">
                        <div>
                          {recentLoading && (
                            <>
                              {" "}
                              <h3 className="recentBlog-Text">Recent Blogs</h3>
                              <div className="ui grid">
                                {blogData && blogData.length > 0 ? (
                                  blogData.map((item, index) => {
                                    return (
                                      <div className="six wide tablet sixteen wide computer column">
                                        <a
                                          href={`/blog/${item.pageurl}`}
                                          target="_blank"
                                        >
                                          <div
                                            className="ui items unstackable"
                                            key={item.id}
                                          >
                                            <div className="item">
                                              <div className="image ui tiny">
                                                <img
                                                  src={item?.featuredimage}
                                                  height="100x"
                                                  width="100px"
                                                  alt={item?.title}
                                                />
                                              </div>
                                              <div className="content">
                                                <div className="meta">
                                                  <span>
                                                    {customdecodeURIComponent(
                                                      item.sidebartitle
                                                    )}
                                                    {/* {customdecodeURIComponent(
                                                      item.sidebartitle
                                                    )
                                                      .split(" ")
                                                      .slice(0, 3)
                                                      .join(" ")}
                                                    {customdecodeURIComponent(
                                                      item.sidebartitle
                                                    ).split(" ").length > 4 &&
                                                      " ..."} */}
                                                  </span>
                                                </div>
                                                <div className="extra">
                                                  <Icon name="time" />
                                                  {timeAgo(item.createdtime)}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <p>No data found</p>
                                )}
                              </div>
                              {/* <p
                                onClick={() => this.handleBack()}
                                className="viewMore"
                              >
                                View More ...
                              </p> */}
                              <button
                                className="ui primary basic button viewMore"
                                onClick={() => this.handleBack()}
                              >
                                View More
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <Grid></Grid>
              </div>
            )}
          </Container>
        </Layout>
      </div>
    );
  }
}

export default Blogdetails;

export async function getStaticProps() {
  return {
    props: {
      query: {},
    },
  };
}